import React from 'react';
import { PulseLoader } from "react-spinners";



function LoaderVisible({ isLoader }) {
    return (
        <>
        {isLoader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )} 
          </>    
    );
}

export default LoaderVisible;